import React, { useEffect, useMemo, useRef, memo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isAuthSelector, extensionAuthActiveSelector } from 'data/selectors/user';

import WhiteLoading from 'components/whiteLoading';
import useLoginPlugin from 'hooks/useLoginPlugin';

const AuthHandler = () => {
  const history = useHistory();
  const isAuthorized = useSelector(isAuthSelector);
  const isExtensionAuthActive = useSelector(extensionAuthActiveSelector);
  const loginPlugin = useLoginPlugin();
  const loginAttempted = useRef(false);

  // Check URL synchronously to avoid race with Redux state.
  // When already logged in, this component mounts before useEffect in App.js
  // dispatches setExtensionAuth, so isExtensionAuthActive may still be false.
  const extensionAuthFromUrl = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('extensionAuth') === 'true' || window.location.pathname === '/extension/auth';
  }, []);

  useEffect(() => {
    if (isAuthorized && !loginAttempted.current) {
      const isExtAuth = isExtensionAuthActive || extensionAuthFromUrl;
      if (isExtAuth) {
        loginAttempted.current = true;
        // Entering the extension-auth flow is user-initiated even when this
        // tab was already authorized - mark it so the push counts as fresh.
        sessionStorage.setItem('gpExtensionFreshLogin', '1');
        loginPlugin(true);
      } else {
        history.push('/');
      }
    }
  }, [isExtensionAuthActive, isAuthorized, loginPlugin, history, extensionAuthFromUrl]); // eslint-disable-line

  return <WhiteLoading height="100vh" width="100%" />;
};

export default memo(AuthHandler);
